// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sch-key-property {
    font-weight: bold;
    margin-bottom: 10px;
}

.sch-toolbar {
    min-width: 100%;
    padding-left: 10px;
    width: 100%;
}

.sch-diagram-container {
    width: 100%;
    height: calc(100% - 58px);
    margin: auto;
    overflow: auto;
}

.sch-diagram {
    height: auto;
    padding-left: 10px;
    position: relative;
    width: 100%;
}

.sch-border-block {
    border-color: #000000;
    border-width: 2px;
}

.sch-border-block div {
    height: 100%;
    width: 100%;
}

.sch-block-container {
    padding: 10px;
    position: absolute;
}

.sch-block {
    align-items: center;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    opacity: 0.4;
}

.sch-block-container-item > div {
    position: absolute;
}

.sch-block-container-item {
    position: relative;
}

.block-content {
    align-items: center;
    cursor: pointer;
    display: flex;
    justify-content: center;
}

.schema-block {
    border-style: dashed;
}

.collateral-block {
    border-style: solid;
}

.selected-block:before {
    border-left: 2px solid #a0c5e8;
    border-right: 2px solid #a0c5e8;
    content: " ";
    height: 25px;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;
}

.selected-block:after {
    border-left: 2px solid #a0c5e8;
    border-right: 2px solid #a0c5e8;
    bottom: 0;
    content: " ";
    height: 25px;
    left: 0;
    position: absolute;
    right: 0;
    z-index: -1;
}

.selected-block-content:before {
    border-bottom: 2px solid #a0c5e8;
    border-top: 2px solid #a0c5e8;
    bottom: 0;
    content: " ";
    left: 0;
    position: absolute;
    top: 0;
    width: 25px;
    z-index: -1;
}

.selected-block-content:after {
    border-bottom: 2px solid #a0c5e8;
    border-top: 2px solid #a0c5e8;
    bottom: 0;
    content: " ";
    position: absolute;
    right: 0;
    top: 0;
    width: 25px;
    z-index: -1;
}`, "",{"version":3,"sources":["webpack://./ClientApp/styles/css/collateralSchema.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,YAAY;IACZ,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;IAC7B,SAAS;IACT,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;IAC7B,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,WAAW;IACX,WAAW;AACf","sourcesContent":[".sch-key-property {\r\n    font-weight: bold;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.sch-toolbar {\r\n    min-width: 100%;\r\n    padding-left: 10px;\r\n    width: 100%;\r\n}\r\n\r\n.sch-diagram-container {\r\n    width: 100%;\r\n    height: calc(100% - 58px);\r\n    margin: auto;\r\n    overflow: auto;\r\n}\r\n\r\n.sch-diagram {\r\n    height: auto;\r\n    padding-left: 10px;\r\n    position: relative;\r\n    width: 100%;\r\n}\r\n\r\n.sch-border-block {\r\n    border-color: #000000;\r\n    border-width: 2px;\r\n}\r\n\r\n.sch-border-block div {\r\n    height: 100%;\r\n    width: 100%;\r\n}\r\n\r\n.sch-block-container {\r\n    padding: 10px;\r\n    position: absolute;\r\n}\r\n\r\n.sch-block {\r\n    align-items: center;\r\n    background-color: #ffffff;\r\n    display: flex;\r\n    justify-content: center;\r\n    opacity: 0.4;\r\n}\r\n\r\n.sch-block-container-item > div {\r\n    position: absolute;\r\n}\r\n\r\n.sch-block-container-item {\r\n    position: relative;\r\n}\r\n\r\n.block-content {\r\n    align-items: center;\r\n    cursor: pointer;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.schema-block {\r\n    border-style: dashed;\r\n}\r\n\r\n.collateral-block {\r\n    border-style: solid;\r\n}\r\n\r\n.selected-block:before {\r\n    border-left: 2px solid #a0c5e8;\r\n    border-right: 2px solid #a0c5e8;\r\n    content: \" \";\r\n    height: 25px;\r\n    left: 0;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n    z-index: -1;\r\n}\r\n\r\n.selected-block:after {\r\n    border-left: 2px solid #a0c5e8;\r\n    border-right: 2px solid #a0c5e8;\r\n    bottom: 0;\r\n    content: \" \";\r\n    height: 25px;\r\n    left: 0;\r\n    position: absolute;\r\n    right: 0;\r\n    z-index: -1;\r\n}\r\n\r\n.selected-block-content:before {\r\n    border-bottom: 2px solid #a0c5e8;\r\n    border-top: 2px solid #a0c5e8;\r\n    bottom: 0;\r\n    content: \" \";\r\n    left: 0;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 25px;\r\n    z-index: -1;\r\n}\r\n\r\n.selected-block-content:after {\r\n    border-bottom: 2px solid #a0c5e8;\r\n    border-top: 2px solid #a0c5e8;\r\n    bottom: 0;\r\n    content: \" \";\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n    width: 25px;\r\n    z-index: -1;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
